export const NOTIFICATIONS_CHANGED = 'notificationPermissionChange';
export const ONESIGNAL_NOTIFICATIONS_LOCAL_KEY =
	'onesignal-notification-prompt';
